import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { InfoCircleIcon } from "./assets";
import { Button, Input } from "./prtnr";
import { fetchCharities } from "./redux/slices/charitiesThunks";
import { fetchStripeAccount } from "./redux/slices/MembersThunks";
import {
  createWalletCharityPayout,
  createWalletPayout,
  fetchWalletBalance,
} from "./redux/slices/WalletSlice";

const ModalContainer = styled.div`
  width: 960px;
  border-radius: 12px;
  padding: 24px;
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--Padding-Normal, 16px);
  align-self: stretch;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Title = styled.h2`
  color: var(--Color-Text-Text, #212543);
  text-align: center;

  font-family: Montserrat;
  font-size: var(--Fonts-H6, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
`;

const Text = styled.p`
  color: var(--Color-Text-Text, #212543);
  text-align: center;

  font-family: Montserrat;
  font-size: var(--Fonts-P4, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  strong {
    color: var(--Color-Text-Text, #212543);

    font-family: Montserrat;
    font-size: var(--Fonts-P4, 14px);
    font-style: normal;
    font-weight: 700;
    line-height: 160%;
  }
`;

const Highlight = styled.span`
  color: var(--Color-Brand-Secoundary, #6162c5);

  font-family: Montserrat;
  font-size: var(--Fonts-H6, 24px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.24px;
`;

const RadioGroup = styled.div`
  display: flex;
  width: 516px;
  margin: 0 auto;
  padding: var(--Padding-Normal, 16px) var(--Padding-Big, 24px) 16px
    var(--Padding-Big, 24px);
  flex-direction: row;
  align-items: flex-start;
  gap: var(--Padding-Small, 8px);
  border-radius: var(--radius-16, 16px);
  border: 1px solid var(--stroke-soft-200, #e1e4ea);
  background: var(--bg-white-0, #fff);
  box-sizing: border-box;

  box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const RadioButton = styled.label`
  display: flex;
  padding: var(--Padding-Normal, 16px) 0 16px 0;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  cursor: pointer;
  font-family: Montserrat;
  font-size: var(--Fonts-P3, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: -0.16px;
  ${({ selected }) =>
    selected
      ? `  color: var(--Color-Text-Text, #6162c5);`
      : `  color: var(--Color-Text-Text, #212543);`}
  input {
    accent-color: #6162c5;
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 518px;
  gap: 16px;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const RootWrapperModalRewardsone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Champagne = styled.img`
  width: 174px;
  height: 174px;
`;

const CharityList = styled.div`
  display: flex;
  width: 516px;
  margin: 0 auto;
  padding: var(--Padding-Normal, 16px) var(--Padding-Big, 24px) 24px
    var(--Padding-Big, 24px);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Padding-Small, 8px);
  align-self: stretch;
  border-radius: var(--radius-16, 16px);
  border: 1px solid var(--stroke-soft-200, #e1e4ea);
  background: var(--bg-white-0, #fff);

  box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
  @media (max-width: 767px) {
    width: 100%;
  }
`;

const CharityItem = styled.label`
  display: flex;
  height: 48px;
  padding: var(--Padding-Normal, 16px) 16px 16px 16px;
  align-items: center;
  justify-content: space-between;
  gap: var(--Padding-Small, 8px);
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid var(--stroke-soft-200, #e1e4ea);
  background: var(--bg-white-0, #fff);

  box-shadow: 0 1px 2px 0 rgba(10, 13, 20, 0.03);
  cursor: pointer;
  &:hover {
    background: #f9f9f9;
  }
  img {
    width: 28px;
    height: 28px;
    margin-right: 10px;
  }

  input {
    accent-color: #6162c5;
  }
`;

const CharityInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--Color-Brand-Primary, #212543);

  font-family: Montserrat;
  font-size: var(--Fonts-P4, 14px);
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
`;
const SelectOption = styled.div`
  color: var(--Color-Text-Text, #212543);

  font-family: Montserrat;
  font-size: var(--Fonts-P3, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  letter-spacing: -0.16px;
`;

const ErrorMessage = styled.div`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
  text-align: start;
`;

const PayoutModal = ({ onClose, balance, memberId, memberType }) => {
  const dispatch = useDispatch();
  const [paymentOption, setPaymentOption] = useState("me");
  const [selectedCharity, setSelectedCharity] = useState(null);
  const [amount, setAmount] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { account } = useSelector((state) => state.members);
  const charities = useSelector((state) => state.charities.items || []);

  // Form validation
  const validateForm = () => {
    const newErrors = {};
    const numericAmount = parseFloat(amount);

    if (!amount || numericAmount <= 0) {
      newErrors.amount = "Please enter a valid amount";
    } else if (numericAmount > balance) {
      newErrors.amount = `Amount cannot exceed your balance of ${formatCurrency(
        balance
      )}`;
    } else if (balance >= 10 && numericAmount < 10) {
      newErrors.amount = "Minimum payment amount is £10";
    } else if (balance < 10 && numericAmount !== balance) {
      newErrors.amount = `Your balance is below £10. You must withdraw the full amount of ${formatCurrency(
        balance
      )}`;
    }

    if (paymentOption === "charity" && !selectedCharity) {
      newErrors.charity = "Please select a charity";
    }

    if (
      paymentOption === "me" &&
      !account?.stripe_account?.live?.external_accounts?.data?.[0]
    ) {
      newErrors.account =
        "No bank account found. Please add your bank details first.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const validateCharityForm = () => {
    const newErrors = {};
    const numericAmount = parseFloat(amount);

    if (!amount || numericAmount <= 0) {
      newErrors.amount = "Please enter a valid amount";
    } else if (numericAmount > balance) {
      newErrors.amount = `Amount cannot exceed your balance of ${formatCurrency(
        balance
      )}`;
    } else if (balance >= 10 && numericAmount < 10) {
      newErrors.amount = "Minimum payment amount is £10";
    } else if (balance < 10 && numericAmount !== balance) {
      newErrors.amount = `Your balance is below £10. You must withdraw the full amount of ${formatCurrency(
        balance
      )}`;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const sendPayoutRequest = async () => {
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    const payload = {
      option: paymentOption,
      charity: selectedCharity,
      amount: parseFloat(amount),
      member_id: memberId,
    };

    try {
      await dispatch(createWalletPayout(payload)).unwrap();
      await dispatch(fetchWalletBalance(memberId));
      onClose();
    } catch (error) {
      console.error("❌ Failed to create payout request:", error);
      setErrors({
        submit:
          error.message || "Failed to create payout request. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const sendCharityPayoutRequest = async () => {
    if (!validateCharityForm()) {
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    const payload = {
      amount: parseFloat(amount),
      member_id: memberId,
    };

    try {
      await dispatch(createWalletCharityPayout(payload)).unwrap();
      await dispatch(fetchWalletBalance(memberId));
      onClose();
    } catch (error) {
      console.error("❌ Failed to create payout request:", error);
      setErrors({
        submit:
          error.message || "Failed to create payout request. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setAmount(value);

      const numericValue = parseFloat(value);

      if (!isNaN(numericValue)) {
        if (numericValue < 0.5) {
          setErrors((prev) => ({
            ...prev,
            amount: `Minimum withdrawal is ${(0.5).toFixed(2)}`,
          }));
        } else if (numericValue > balance) {
          setErrors((prev) => ({
            ...prev,
            amount: "Amount exceeds available balance",
          }));
        } else {
          setErrors((prev) => ({ ...prev, amount: null }));
        }
      } else {
        setErrors((prev) => ({ ...prev, amount: null }));
      }
    }
  };
  const handlePaymentOptionChange = (option) => {
    setPaymentOption(option);
    setErrors((prev) => ({
      ...prev,
      charity: null,
      account: null,
    }));

    if (option === "me") {
      setSelectedCharity(null);
    }
  };

  useEffect(() => {
    dispatch(fetchStripeAccount(memberId));
    dispatch(fetchCharities());
  }, [dispatch]);

  // Set max amount to balance
  useEffect(() => {
    if (amount && parseFloat(amount) > balance) {
      setAmount(balance.toString());
    }
  }, [balance]);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    }).format(value);
  };
  return (
    <RootWrapperModalRewardsone>
      <Overlay>
        <ModalContainer>
          <Champagne src="https://d3nakrlcog1u3z.cloudfront.net/1751293449884-image (4).png" />
          <Title>
            Request Payout <Highlight>£{balance}</Highlight>
          </Title>
          <Text>
            You’re about to request a payout from Member's available balance.
            <br />
            Please ensure their payment method is up to date. Payouts are
            usually processed within 3–5 business days.
          </Text>

          <RadioGroup>
            <RadioButton
              selected={paymentOption === "me"}
              onClick={() => handlePaymentOptionChange("me")}
            >
              <input
                type="radio"
                checked={paymentOption === "me"}
                onChange={() => handlePaymentOptionChange("me")}
                aria-describedby={errors.account ? "account-error" : undefined}
              />
              Pay to member
            </RadioButton>

            <RadioButton
              selected={paymentOption === "charity"}
              onClick={() => handlePaymentOptionChange("charity")}
            >
              <input
                type="radio"
                checked={paymentOption === "charity"}
                onChange={() => handlePaymentOptionChange("charity")}
                aria-describedby={errors.charity ? "charity-error" : undefined}
              />
              Donate to Charity
            </RadioButton>
          </RadioGroup>

          {memberType === "Individual" && paymentOption === "me" && (
            <CharityList>
              <SelectOption>Account Details</SelectOption>
              <Frame1481>
                <p>Bank Name</p>
                <span>
                  {account?.stripe_account?.live?.external_accounts?.data?.[0]
                    ?.bank_name || ""}
                </span>
              </Frame1481>

              <Frame1481>
                <p>Account Number</p>
                <span>
                  {account?.stripe_account?.live?.external_accounts?.data?.[0]
                    ? `**** **** **** ${account.stripe_account.live.external_accounts.data[0].last4}`
                    : ""}
                </span>
              </Frame1481>
            </CharityList>
          )}

          {paymentOption === "charity" && (
            <CharityList>
              <SelectOption>Select Charity</SelectOption>
              {charities.map((charity) => (
                <CharityItem key={charity._id}>
                  <CharityInfo>
                    <img src={charity.logo} alt={charity.name} />
                    {charity.name}
                    <TooltipWrapper>
                      <GFeildsInfo src={InfoCircleIcon} alt="icon" />
                      <TooltipText className="tooltip">
                        {charity.short_description}
                      </TooltipText>
                    </TooltipWrapper>
                  </CharityInfo>
                  <input
                    type="radio"
                    checked={selectedCharity === charity._id}
                    onChange={() => setSelectedCharity(charity._id)}
                  />
                </CharityItem>
              ))}
            </CharityList>
          )}

          <CharityList>
            <Input
              label={
                paymentOption === "me"
                  ? "Enter Amount to Withdraw"
                  : "Enter Amount to Donate to Charity"
              }
              required
              type="number"
              min="0.01"
              max={balance}
              step="0.01"
              value={amount}
              onChange={handleAmountChange}
              placeholder={`Max: ${formatCurrency(balance)}`}
              error={errors.amount}
              errorMessage={errors.amount}
              aria-describedby={errors.amount ? "amount-error" : undefined}
            />
          </CharityList>
          {errors.submit && <ErrorMessage>{errors.submit}</ErrorMessage>}
          {errors.charity && <ErrorMessage>{errors.charity}</ErrorMessage>}

          <ButtonRow>
            <Button variant="gray" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button
              variant="black"
              onClick={
                paymentOption === "charity"
                  ? sendPayoutRequest
                  : sendCharityPayoutRequest
              }
              disabled={isSubmitting || !amount}
            >
              {isSubmitting ? "Processing..." : "Submit Request"}
            </Button>
          </ButtonRow>
        </ModalContainer>
      </Overlay>
    </RootWrapperModalRewardsone>
  );
};

export default PayoutModal;

const Frame1481 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Padding-Tiny, 4px);
  align-self: stretch;
  p {
    color: var(--Color-Text-Gray, #64748b);

    font-family: Montserrat;
    font-size: var(--Fonts-P4, 14px);
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
  }
  span {
    color: var(--inputs-default-label-text, #000);

    font-family: Montserrat;
    font-size: var(--Fonts-P3, 16px);
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
    letter-spacing: -0.16px;
  }
`;
const GFeildsInfo = styled.img`
  width: 14px !important;
  height: 14px !important;
`;

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  margin-top: 4px;

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;

const TooltipText = styled.div`
  visibility: hidden;
  color: #000000;
  font-weight: 500;
  font-size: 12px;
  text-align: start;
  padding: 8px 16px;
  border-radius: 4px;
  position: absolute;
  z-index: 1;
  top: 125%;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s;
  max-width: 280px;
  width: 280px;
  backdrop-filter: blur(20px);
  background: var(--backgrounds-primary, #ffffff);
  font-family: "Montserrat", sans-serif;
  &::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -6px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent var(--backgrounds-primary, #ffffff)
      transparent;
  }
`;
